<template>
  <v-app>
    <!-- LOAD MODAL-->
    <v-dialog
      v-model="this.$store.getters.isShowLoadingMessage"
      no-click-animation
      :scrollable="true"
      width="300"
    >
      <v-card color="black" dark>
        <v-card-text>
          {{ this.$store.state.loadingMessage }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- ERROR MODAL-->
    <v-dialog v-model="isShowError" max-width="700">
      <v-btn ref="errorDialogBtn" style="display: none"></v-btn>
      <v-card>
        <v-card-title
          v-if="this.$store.getters.errorTitle"
          class="title lighten-2"
        >
          <v-icon class="error--text mr-1">mdi-alert-circle</v-icon>
          {{ this.$store.getters.errorTitle }}
        </v-card-title>
        <v-card-text class="black--text mt-1">
          {{ this.$store.getters.errorMessage }}
        </v-card-text>
        <v-card-actions text-center>
          <v-spacer></v-spacer>
          <v-btn
            color="info"
            :style="{ color: this.$store.state.nexaConfig.INFO_COLOUR_TEXT }"
            @click="isShowError = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- OVERLAY MODAL-->
    <v-dialog
      v-model="this.$store.getters.isShowOverlay"
      no-click-animation
      max-width="700"
      persistent
    >
      <v-card color="tertiary">
        <v-card-title
          v-if="this.$store.getters.overlayTitle"
          class="title grey lighten-2"
          primary-title
          >{{ this.$store.getters.overlayTitle }}</v-card-title
        >
        <v-card-text>
          {{ this.$store.getters.overlayMessage }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="info"
            :style="{ color: this.$store.state.nexaConfig.INFO_COLOUR_TEXT }"
            @click="solveOverlay()"
          >
            {{ this.$store.getters.overlayButtonLabel }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- TOOLBAR/HEADER -->
    <!-- <v-toolbar
      :dense="hasCustomHeader"
      :extended="!hasCustomHeader"
      :extension-height="!hasCustomHeader ? 70 : 0"
      flat
      v-if="isConfigLoaded"
      color="blue"
      class="pa-0"
    > -->
    <v-toolbar
      extended
      extension-height="44"
      flat
      v-if="isConfigLoaded"
      class="pa-0 flex-grow-0"
      style="display: flex; padding-top: 15px !important; width: 95%"
    >
      <div
        v-if="!this.$store.state.nexaConfig.CUSTOM_HEADER"
        style="width: 100%; height: 100%"
        class="pa-3"
      >
        <router-link to="/">
          <span v-if="this.$store.state.nexaConfig.SMALLER_LOGO.length > 0">
            <img
              v-if="this.$store.state.nexaConfig.LOGO_PATH.length > 0"
              :src="this.$store.state.nexaConfig.LOGO_PATH"
              class="mq-logo mq-logo-smaller"
            />
          </span>
          <span v-else>
            <img
              v-if="this.$store.state.nexaConfig.LOGO_PATH.length > 0"
              :src="this.$store.state.nexaConfig.LOGO_PATH"
              class="mq-logo"
            />
          </span>
          <img
            v-if="this.$store.state.nexaConfig.LOGO_PATH.length == 0"
            src="@/assets/logo.png"
            class="mq-logo"
          />
        </router-link>
        <v-spacer></v-spacer>
      </div>

      <div
        style="width: 100%; height: 100%"
        v-if="this.$store.state.nexaConfig.CUSTOM_HEADER"
        v-html="this.$store.state.nexaConfig.CUSTOM_HEADER"
      ></div>
      <div
        class="d-flex pt-3"
        style="position: absolute; right: 0; width: 100%"
      >
        <v-spacer></v-spacer>
        <div
          v-if="isStudentIdExist()"
          class="name-id"
          :style="{
            color: getConfigItem('APPBAR_COLOUR_TEXT'),
          }"
        >
          <div>{{ studentId }}</div>
          <div>{{ this.$store.state.nexaConfig.NAME_TEXT }}{{ firstName }}</div>
        </div>
        <div
          v-else
          class="name-id"
          :style="{
            color: getConfigItem('APPBAR_COLOUR_TEXT'),
          }"
        >
          <div>{{ this.$store.state.nexaConfig.NAME_TEXT }}</div>
        </div>
      </div>
    </v-toolbar>
    <v-menu v-if="isConfigLoaded">
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
          style="
            display: block;
            position: absolute;
            font-size: 30px;
            right: 0;
            margin-right: 20px;
            margin-top: 27px !important;
          "
        >
          <v-icon
            :style="{
              color: getConfigItem('APPBAR_COLOUR_TEXT'),
            }"
            >mdi-dots-vertical</v-icon
          >
        </v-btn>
      </template>
      <v-list>
        <v-list>
          <v-list-item
            v-if="this.homeUrl != '' && this.homeTitle != ''"
            :href="this.homeUrl"
          >
            <v-list-item-title>
              {{ this.homeTitle }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.bookingUrl != ''"
            :href="this.bookingUrl"
            target="_blank"
          >
            <v-list-item-title>
              {{ this.bookingTitle }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.openingHoursUrl != ''"
            :href="this.openingHoursUrl"
            target="_blank"
          >
            <v-list-item-title>{{ this.openingHoursTitle }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="signout()" style="box-shadow: none">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-list>
    </v-menu>

    <!-- CONTENT -->
    <v-spacer></v-spacer>
    <v-main v-if="isConfigLoaded">
      <router-view></router-view>
    </v-main>
    <v-spacer></v-spacer>
    <!-- FOOTER -->
    <v-footer
      height="auto"
      class="pa-0"
      v-if="isConfigLoaded && this.$store.state.nexaConfig.CUSTOM_FOOTER != ''"
    >
      <v-card class="flex" flat tile>
        <div v-html="this.$store.state.nexaConfig.CUSTOM_FOOTER"></div>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import cookieMixin from "@/mixins/cookieMixin";
import loadingMixin from "@/mixins/loadingMixin";
import configAliasMixin from "@/mixins/configAliasMixin";
import { mapGetters } from "vuex";
import { helper } from "@/helper";

export default {
  name: "App",
  mixins: [cookieMixin, loadingMixin, configAliasMixin],

  // data: function() {
  //   return {

  //   };
  // },

  computed: {
    ...mapGetters([
      "isConfigLoaded",
      "isShowLoadingMessage",
      "getConfigItemNestedObjectValue",
      "getConfigItem",
    ]),
    hasCustomHeader() {
      return (
        this.$store.state.nexaConfig.CUSTOM_HEADER &&
        this.$store.state.nexaConfig.CUSTOM_HEADER != ""
      );
    },
    isShowError: {
      get() {
        return this.$store.getters.isShowError;
      },
      set(newValue) {
        this.$store.commit("setIsShowError", newValue);
      },
    },
  },
  mounted: function () {
    // console.log("App mounted", this.$store.state.loadingMessage);
    this.$vuetify.theme.themes.light.primary = this.$store.state.nexaConfig.PRIMARY_COLOUR;
    this.$vuetify.theme.themes.light.secondary = this.$store.state.nexaConfig.SECONDARY_COLOUR; //'#292625';
    this.$vuetify.theme.themes.light.info = this.$store.state.nexaConfig.INFO_COLOUR;
    this.$vuetify.theme.themes.light.error = this.$store.state.nexaConfig.ERROR_COLOUR;
    this.$vuetify.theme.themes.light.warning = this.$store.state.nexaConfig.WARNING_COLOUR;
    if (this.$store.state.nexaConfig.APP_NAME) {
      document.title = this.$store.state.nexaConfig.APP_NAME;
    }
  },
  methods: {
    signout() {
      if (process.env.VUE_APP_ISDEBUGGING)
        console.log("%c signout!", "color:red", {
          requiresAuth: this.getConfigItem("REQUIRES_AUTHENTICATION", true),
          homeUrl: this.homeUrl,
          logoutUrl: this.$store.state.nexaConfig.LOGOUT_URL,
          currentRoute: this.$router.currentRoute,
        });

      helper.deleteUserCookie();
      //helper.deleteCaseCookie();

      if (!this.getConfigItem("REQUIRES_AUTHENTICATION", true)) {
        if (
          this.$router.currentRoute.name == "home" &&
          window.location.href == this.homeUrl
        ) {
          window.location.reload();
        } else {
          //window.location.replace(this.homeUrl);
          window.location.replace(this.$store.state.nexaConfig.LOGOUT_URL);
        }
      } else {
        window.location.replace(this.$store.state.nexaConfig.LOGOUT_URL);
      }
    },
  },
  watch: {
    // isShowError: function (newValue, oldValue) {
    //   if (oldValue && !newValue) this.$router.push("/");
    // },
  },
};
</script>

<style scoped>
.v-application {
  background-color: white !important;
  max-width: 768px;
  margin: 0 auto;
  -webkit-box-shadow: 0px 0px 46px -25px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 46px -25px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 46px -25px rgba(0, 0, 0, 0.75);
}
.mq-logo {
  min-width: 150px;
  max-width: 100%;
  max-height: 100px;
  object-fit: contain;
}

.mq-logo-smaller {
  max-height: 86px;
}

.override-prepend-outer .v-input__prepend-outer {
  display: inline;
}

@media only screen and (max-width: 320px) {
  .cancel-btn {
    font-size: 11px;
  }
  .name-id {
    font-size: 10px;
    margin-left: 5px;
    text-align: right;
  }
}
</style>
<style>
.v-toolbar__content {
  padding: 0 !important;
  width: 100%;
}
</style>
